module.exports = __webpack_public_path__ + "img/turanza6_banner.921ac915.jpg";